export default "__VITE_ASSET__CVVa1aPt__"